import { useLink } from "@react-aria/link"
import { waTriggerEvent } from "components/analytics/DigitalDataLayer"
import { PopinButton } from "components/components"
import A11yModal from "components/footer/A11yModal"
import WeChatModal from "components/footer/WeChatModal"
import { Icon } from "components/icon/Icon"
import { useDictionary } from "contexts/Dictionary"
import { useNavigation } from "contexts/Navigation"
import { AnimatePresence } from "framer-motion"
import { useRef, useState } from "react"
import { createPortal } from "react-dom"

function trackOutlink(href, name) {
  waTriggerEvent({
    eventName: "outlink",
    eventType: "Click",
    outlinkInfo: { linkURL: href, linkName: name },
  })
}

function trackContactForm() {
  waTriggerEvent({ eventName: "FormItClicked", eventType: "Click" })
}

function ModalLink({ children, renderModal, onOpen, ...props }) {
  const [isOpen, setIsOpen] = useState(false)

  const open = () => {
    setIsOpen(true)
    onOpen?.()
  }

  const close = () => setIsOpen(false)

  return (
    <>
      <button {...props} type='button' onClick={open}>
        {children}
      </button>
      {process.browser && createPortal(<AnimatePresence>{isOpen && renderModal(close)}</AnimatePresence>, document.body)}
    </>
  )
}

export default function CategoryLink({ label, name, target, href, external, reference, outlink_name, social, opensModal, wechat, modal }) {
  const dictionary = useDictionary()
  const navigation = useNavigation()
  const ref = useRef()
  const { linkProps } = useLink({}, ref)

  if (reference?.[0]?.uid) {
    return (
      <PopinButton
        hasNoGestur
        stylesForCFI
        className='inline'
        label={label}
        reference={reference}
        triggerFormItEvent={href === "#ContactForm" ? trackContactForm : undefined}
      />
    )
  }

  if (social) {
    const icon = label.toLowerCase()

    if (icon === "wechat") {
      return (
        <ModalLink
          aria-label={`${label} - ${dictionary.openInPopin()}`}
          onOpen={() => trackOutlink("https://weixin.qq.com/r/LkjSykbE3xugrQKp9x08", "WeChat")}
          renderModal={onClose => <WeChatModal {...wechat} onClose={onClose} />}
        >
          <Icon type={icon} />
          {name || label}
        </ModalLink>
      )
    }

    return (
      <a
        {...linkProps}
        ref={ref}
        aria-label={`${label} - ${dictionary.openInNewTab()}`}
        href={href}
        rel='noopener noreferrer'
        target='_blank'
        onClick={() => trackOutlink(href, label)}
      >
        <Icon type={icon} />
        {name || label}
      </a>
    )
  }

  if (opensModal) {
    return <ModalLink renderModal={onClose => <A11yModal {...modal} onCloseA11yModal={onClose} />}>{label}</ModalLink>
  }

  if (target === "external") {
    const url = external || href

    return (
      <a
        {...linkProps}
        ref={ref}
        className='inline reverseIcon'
        href={url}
        target='_blank'
        rel='noopener noreferrer nofollow'
        aria-label={`${label} - ${dictionary.openInNewTab()}`}
        onClick={() => trackOutlink(url, outlink_name || label)}
      >
        {label}
        <Icon type='externalLink' />
      </a>
    )
  }

  const navigate = e => {
    e.preventDefault()
    navigation.navigate(e.currentTarget.getAttribute("href"))
  }

  return (
    <a {...linkProps} ref={ref} href={navigation.localize(href)} onClick={navigate}>
      {label}
    </a>
  )
}
